import HeroSection from '../components/home/HeroSection';
import WhatWeDoBanner from '../components/home/WhatWeDoBanner';
import AboutUs from '../components/home/AboutUs';
import ServicesSection from '../components/home/ServicesSection';
import CompostOptions from '../components/home/CompostOptions';
import StayInTheKnow from '../components/home/StayInTheKnow';
import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { trackPageView, getSessionId, getUserId } from '../utils/pageTracking';
import SaleBanner from '../components/SaleBanner';


const Home: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view
    trackPageView('Home', getSessionId(), getUserId());
    
    // Scroll to top when page loads
    window.scrollTo(0, 0);

    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <div className="flex flex-col w-full min-h-screen bg-white pt-24 sm:pt-28">
      <SaleBanner />
      <HeroSection />
      <WhatWeDoBanner />
      <ServicesSection />
      <StayInTheKnow />
      <AboutUs />
      <CompostOptions />    
      
      {/* Contact Us Button Section */}
      <section className="py-12 bg-[#c3d3ab]">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-[#b05e2c] mb-6">
            Have Questions?
          </h2>
          <p className="text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
            We're here to help you get started with composting or answer any questions about our services.
          </p>
          <Link
            to="/contact-us"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="inline-block bg-[#b05e2c] text-white px-8 py-4 rounded-lg hover:bg-[#924d24] transition-colors font-semibold text-lg"
          >
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
